import { TextField, Button } from '@mui/material';
import { WhatsApp, LinkedIn, Facebook, Instagram } from '@mui/icons-material';
import { H5 } from '../../themes/typography';

function ShareEvent({
    eventUrl = window.location.href,
    onCopy = () => { navigator.clipboard.writeText(eventUrl); }
}) {
    return (
        <div className="event-preview-share-event-container">
            <H5 fontWeight={700}>Share Event</H5>

            <div className="event-preview-sharing-container">
                <div className="preview-share-input-button">
                    <TextField fullWidth size="small" placeholder={eventUrl} />
                    <Button variant="main" onClick={onCopy}>Copy</Button>
                </div>

                <div className="preview-event-social-icons">
                    <WhatsApp sx={socialIconStyles} />
                    <LinkedIn sx={socialIconStyles} />
                    <Facebook sx={socialIconStyles} />
                    <Instagram sx={socialIconStyles} />
                </div>
            </div>
        </div>
    );
}

export default ShareEvent;

const socialIconStyles = {
    fontSize: '2rem',
    color: 'var(--secondary-color)'
};
